export const parseAmount = (amount: string) => {
  return Number(amount.replace(/[^0-9.]/g, ""));
};

const moneyFieldRegExp = /([0-9.]+) (\w+)/;

export const formatCurrency = (amount: string | number | null, currencyCode: string = "USD") => {
  let number = 0;
  let currency = currencyCode;

  if (typeof amount === "number") {
    number = amount;
  } else if (amount === null) {
    number = 0;
  } else if (typeof amount === "string") {
    const result = moneyFieldRegExp.exec(amount);
    if (result && result.length >= 3) {
      number = Number(result[1]);
      // eslint-disable-next-line prefer-destructuring
      currency = result[2];
    } else {
      number = Number(amount);
    }
  }

  const formatter = new Intl.NumberFormat("bestfit", {
    style: "currency",
    currency,
  });

  return formatter.format(number);
};
